



























































































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Component } from "vue-property-decorator";
import { $api } from "@/services/ApiService";
import { KeyCsrPayload } from "bancojs";

@Component
export default class AdminKeysCsrCreate extends Vue {
  async created() {
    if (this.$route.params.key_id) {
      this.form.loading = true;
      try {
        const res = await $api.client.admin.keys
          .get(Number(this.$route.params.key_id))
          .toPromise();
        if (res.wrapping_key_id) this.form.requiredPin = true;
        this.form.loading = false;
      } catch (err) {
        console.log(err);
        this.form.loading = false;
      }
    }
  }
  
  async saveCsr() {
    if (this.$route.params.key_id) {
      this.form.loading = true;
      try {
        await $api.client.admin.keys
          .createCsr(Number(this.$route.params.key_id), this.form.data)
          .toPromise();
        this.form.loading = false;
        this.$router.push("/admin/keys/" + this.$route.params.key_id + "/csr");
      } catch (err) {
        console.log(err);
        this.form.loading = false;
      }
    }
  }

  rules = {
    required: (val: any) => !!val || "Campo requerido.",
    email: (val: any) => /.+@.+/.test(val) || 'Email inválido.',
    requiredPin(requiredPin: boolean, val: any) {
      if (!requiredPin) return true;
      else return !!val || 'Campo requerido.';
    },
    maxPin: (val: any) => val.length <= 16 || "El campo es mayor a 16 caracteres.",
  };

  form: {
    data: KeyCsrPayload;
    loading: boolean;
    validForm: boolean;
    requiredPin: boolean;
  } = {
    data: {
      commonname: "",
      country: "",
      state: "",
      locality: "",
      organization: "",
      organization_unit: "",
      email: "",
      serialnumber: "",
      pin: ""
    },
    loading: false,
    validForm: false,
    requiredPin: false,
  };
}
